
export default {
	name: "ThrownFire",
	image: "fire-fx.png",
	emissionType: "point",
	lifetime: 5,
	loop: true,
	particleLife: 1,
    outerRadius: 3,
	maxParticles: 1000,
	blendMode: "ADD",
	emissionRate: 180,
	dontCacheParticles: true,
	maintainWorldPos: true,
	attributes: [
		{
			type: "VELOCITY",
			randomVelocity: {
				minX: -2,
				maxX: 2,
				minY: -7,
				maxY: 0
			}
		},
		{
			type: "SCALE",
			squareScale: true,
			scaleOverTime: true,
			randomlyMirror: {
				onlyX: true
			},
			randomScale: {
				minX: 0.1,
				maxX: 0.2
			},
			finalScale: {
				x: 0
			}
		},
		{
			type: "COLOUR",
			initialColour: {
				r: 122,
				g: 30,
				b: 5,
			}
		},
	]
}
